export const ACTION_TYPES = {
    CLEAR_APPOINTMENT_STATUS_LIST_ERROR: 'CLEAR_APPOINTMENT_STATUS_LIST_ERROR',
    CLEAR_APPOINTMENT_STATUS_LIST: 'CLEAR_APPOINTMENT_STATUS_LIST',
    LOAD_APPOINTMENT_STATUS_LIST_REQUEST: 'LOAD_APPOINTMENT_STATUS_LIST_REQUEST',
    LOAD_APPOINTMENT_STATUS_LIST_SUCCESS: 'LOAD_APPOINTMENT_STATUS_LIST_SUCCESS',
    LOAD_APPOINTMENT_STATUS_LIST_FAILURE: 'LOAD_APPOINTMENT_STATUS_LIST_FAILURE'
};
